


































































import { Vue, Component, Prop } from "@/shared/vuepack";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import HsabExpenseTable from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseTable.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    HsabExpenseTable,
    SideBar,
    HsabExpenseForm
  }
})
export default class HsabExpenseManagement extends Vue {
  hsabExpense = useHsabExpenseStore();
  userStore = useUserStore();
  RouteNames = RouteNames;
  showExpenseAddView = false;
  themeStore = useThemeStore();

  mounted () {
      this.hsabExpense.loadExpenses();
  }

  addExpenseAction (event: any) {
    event.preventDefault();
    this.showExpenseAddView = true;
  }

  handleCloseAction () {
    this.showExpenseAddView = false;
  }

  handleSwitchAvailableExpensePage (pageNumber: number) {
    this.hsabExpense.loadPageAvailableExpenses({ page: pageNumber, force: true });
  }

  handleSwitchSubmittedExpensePage (pageNumber: number) {
    this.hsabExpense.loadPageSubmittedExpenses({ page: pageNumber, force: true });
  }

  @Prop()
  activeTab: string;

  get activeTabIndex () {
    return Array.from(this.tabChoiceUrls.keys())
      .findIndex(i => i.params.activeTab === this.activeTab);
  }
  get totalSubmitted (): number {
    return this.hsabExpense.submittedExpensesLoaded
    ? this.hsabExpense.submittedExpenses.totalRecords
    : 0;
  }
  get submittedTabHeader (): string {
    return this.totalSubmitted === 1 ? "1 Submitted Expense" : `${this.totalSubmitted} Submitted Expenses`;
  }
  get totalAvailable (): number {
    return this.hsabExpense.availableExpensesLoaded
    ? this.hsabExpense.availableExpenses.totalRecords
    : 0;
  }
  get availableTabHeader (): string {
    return this.totalAvailable === 1 ? "1 Available Expense" : `${this.totalAvailable} Available Expenses`;
  }
  get tabChoiceUrls () {
    const tabMap = new Map([
      [ { name: RouteNames.HsabExpenseManagement, params: { activeTab: RouteNames.HsabExpenseManagementAvailable } },
        this.availableTabHeader ]
    ]);
    tabMap.set({ name: RouteNames.HsabExpenseManagement, params: { activeTab: RouteNames.HsabExpenseManagementSubmitted } },
        this.submittedTabHeader);
    return tabMap;
  }
}
